import React from 'react'
import {Lang} from 'yougile-lang'
import {IconButton} from '@components/common/base/buttons'

interface Props {
  onClick?: (e: React.MouseEvent) => void
}

export const DeleteButton = ({onClick}: Props) => (
  <IconButton
    icon="IconTrash"
    size="small"
    className="flex-none"
    wrapperSize="big"
    bgStyle="message"
    content={Lang.msg.messageDeleteHint}
    onClick={onClick}
  />
)
